import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import routes from '../../../routes';
import {
  Badge,
  CTA,
  CustomInput,
  CustomSelect,
  HtmlRaw,
  NoResult,
  Text,
} from '../../../ui/atoms';
import {
  FiltersWrapper,
  DocumentsGrid,
  SelectWrapper,
  Legend,
  Title,
  DocumentUpload,
} from './style';
import Pagination from '../../../ui/atoms/Pagination';
import {
  DOCUMENTS_EXPERT_CATEGORIES_GET,
  DOCUMENTS_EXPERT_LIST_GET,
} from '../../redux/actions/documentsExpert';
import CardDocuments from '../../../ui/atoms/Cards/CardDocuments';
import {
  CategoriesWrapper,
  CategoryCard,
  PageGrid,
  ResultsSorting,
} from '../CourseList/style';
import { flattenCategories } from '../../../utils/categories';
import { Container } from '../../../ui/gridSystem';
import SortBy from '../../../ui/atoms/SortBy';
import {
  VISIBILITY_OPTIONS,
  formatFilterOpt,
  getFilterLabel,
} from '../../../utils/labels';
import { SEARCH_DOCUMENTS_EXPERT_LIST_GET } from '../../redux/actions/search';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../redux/actions';
import ModalCategories, {
  ModalCategoriesId,
} from '../../../ui/atoms/Modals/ModalCategories';
import ModalCreateDocument, {
  ModalCreateDocumentId,
} from '../../../ui/atoms/Modals/ModalCreateDocument';
import ModalDocDLConfirm from '../../../ui/atoms/Modals/ModalDocDLConfirm';

const DocumentsExpert = ({
  mediaIsPhone,
  getDocuments,
  isSupervisor,
  searchDocuments,
  list,
  filters,
  pager,
  getCategories,
  categories,
  modalOpen,
}) => {
  const navigate = useNavigate();
  const [currentArea, setCurrentArea] = useState({});
  const [subjects, setSubjects] = useState([]);
  //  filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  const handleGetDocuments = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    // set categories & categoryType
    if (selectedFilters?.subject) {
      parsedFilters.single_categories = selectedFilters?.subject;
    } else parsedFilters.parent_categories = currentArea?.id;

    const title = parsedFilters?.title;
    delete parsedFilters?.title;
    delete parsedFilters?.subject;
    if (title) {
      searchDocuments({ title, filters: parsedFilters });
    } else getDocuments(parsedFilters);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (categories?.length <= 0) getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentArea?.id) {
      const newSubjects = flattenCategories(currentArea?.children, 0, true);
      setSubjects(newSubjects);
    } else setSubjects([]);
    setSelectedFilters({ ...selectedFilters, subject: undefined });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentArea]);

  useEffect(() => {
    handleGetDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickCategory = (c) => {
    if (currentArea.id === c.id) setCurrentArea({});
    else setCurrentArea(c);
  };

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, title: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetDocuments(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <>
      <Container>
        <Title>
          <Text type="h1" mb={mediaIsPhone ? 24 : 32}>
            Scambio documentale
          </Text>
          <DocumentUpload>
            <Text type="b4">Carica e scambia i documenti.</Text>
            <CTA
              btnText="Carica documentazione"
              icon="upload-01"
              type="tertiary"
              onClick={() =>
                modalOpen(ModalCreateDocumentId, {
                  callback: () => handleGetDocuments(),
                })
              }
            />
          </DocumentUpload>
        </Title>
        <PageGrid>
          {mediaIsPhone ? (
            <StickyFiltersWrapper mb={16}>
              <CTA
                btnText="CAMBIA AREA TEMATICA"
                fullsize
                onClick={() =>
                  modalOpen(ModalCategoriesId, {
                    categories,
                  })
                }
              />
            </StickyFiltersWrapper>
          ) : (
            <div>
              <Text type="h2" className="pb-3 category-title">
                Risorse
              </Text>
              <CategoriesWrapper>
                {(categories || []).map((c) => {
                  if (!c.documentsByCategory) return null;
                  return (
                    <CategoryCard
                      key={`category-${c?.id}`}
                      onClick={() => onClickCategory(c)}
                      className={currentArea?.id === c?.id ? 'active' : ''}
                    >
                      <div className="label">{c.label}</div>
                      {c?.documentsByCategory && (
                        <Badge
                          type="counter"
                          active={currentArea?.id === c?.id}
                          notification={c?.hasNewDocuments}
                        >
                          {c.documentsByCategory}
                        </Badge>
                      )}
                    </CategoryCard>
                  );
                })}
              </CategoriesWrapper>
            </div>
          )}
          <div>
            <Text type="h1.5" mb={16}>
              {currentArea?.label ?? 'Tutti i documenti'}
            </Text>
            {currentArea?.description && (
              <Text type="b3" mb={42}>
                <HtmlRaw html={currentArea.description} />
              </Text>
            )}

            {mediaIsPhone ? (
              <StickyFiltersWrapper mb={16} stickyPosition={1}>
                <CustomInput
                  placeholder="Cosa vuoi cercare?..."
                  isSearch
                  value=""
                  icon="search-sm"
                  isClearable
                  onChange={(v) => setSearchValue(v)}
                  onClickIcon={onClickSearch}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') onClickSearch();
                  }}
                />
                <CTA
                  classes="small-btn"
                  btnText="Filtri"
                  type="secondary"
                  fullsize
                  onClick={() =>
                    modalOpen(ModalFiltersId, {
                      filters: isSupervisor
                        ? {
                            subject: subjects,
                            ...filters,
                            published: VISIBILITY_OPTIONS,
                          }
                        : {
                            subject: subjects,
                            ...filters,
                          },
                      activeFilters: selectedFilters,
                    })
                  }
                />
              </StickyFiltersWrapper>
            ) : (
              <>
                <FiltersWrapper>
                  <SelectWrapper>
                    <CustomInput
                      placeholder="Cosa vuoi cercare?..."
                      isSearch
                      value=""
                      icon="search-sm"
                      isClearable
                      onChange={(v) => setSearchValue(v)}
                      onClickIcon={onClickSearch}
                      onKeyPress={(event) => {
                        if (event?.key === 'Enter') onClickSearch();
                      }}
                    />
                  </SelectWrapper>
                  {subjects?.length > 0 && (
                    <SelectWrapper>
                      <CustomSelect
                        placeholder="Materia"
                        options={subjects}
                        isClearable
                        onChange={(v) =>
                          setSelectedFilters({
                            ...selectedFilters,
                            subject: v?.value,
                          })
                        }
                        selected={
                          subjects?.find(
                            (s) => s.value === selectedFilters?.subject
                          ) ?? null
                        }
                      />
                    </SelectWrapper>
                  )}
                  {(Object.keys(filters) || []).map((key, i) => (
                    <SelectWrapper key={`filter-${i}`}>
                      <CustomSelect
                        placeholder={getFilterLabel(key)}
                        options={filters[key].map((opt) =>
                          formatFilterOpt(opt)
                        )}
                        onChange={(value) => handleOnChange({ key, value })}
                        isClearable
                      />
                    </SelectWrapper>
                  ))}
                  {isSupervisor && (
                    <SelectWrapper>
                      <CustomSelect
                        placeholder="Visibilità"
                        options={VISIBILITY_OPTIONS}
                        onChange={(value) =>
                          handleOnChange({ key: 'published', value })
                        }
                        isClearable
                      />
                    </SelectWrapper>
                  )}
                </FiltersWrapper>
                <ResultsSorting>
                  <Text type="b3" className="found-results">
                    {pager?.total_items} documenti disponibili
                  </Text>
                  <SortBy
                    onChange={(v) => {
                      setSelectedFilters({
                        ...selectedFilters,
                        sort_by: v?.value,
                      });
                    }}
                  />
                </ResultsSorting>
              </>
            )}
            {list?.length > 0 ? (
              <>
                {!mediaIsPhone && (
                  <Legend
                    className={isSupervisor ? 'supervisor-documents' : ''}
                  >
                    <p>FORMATO</p>
                    <p>TITOLO </p>
                    <p>TIPOLOGIA </p>
                    {isSupervisor && <p>Visibilità </p>}
                    <p>DATA</p>
                    <p>DIMENSIONI</p>
                  </Legend>
                )}
                <DocumentsGrid>
                  {(list || []).map((item) => (
                    <CardDocuments
                      key={`document-${item?.id}`}
                      item={item}
                      onClick={() =>
                        navigate(
                          `${routes.documentExpertDetails.path}/${item.id}`
                        )
                      }
                      handleGetDocuments={handleGetDocuments}
                      isExpertDocument
                      className={isSupervisor ? 'supervisor-documents' : ''}
                    />
                  ))}
                </DocumentsGrid>
                <Pagination
                  pager={pager}
                  callBack={loadMore}
                  setItemsPerPage={setItemsPerPage}
                />
              </>
            ) : (
              <NoResult />
            )}
          </div>
        </PageGrid>
      </Container>
      <ModalCreateDocument />
      <ModalDocDLConfirm />
      {mediaIsPhone && (
        <>
          <ModalFilters
            onClick={(newFilters) =>
              setSelectedFilters({
                ...newFilters,
                title: selectedFilters.title,
              })
            }
          />
          <ModalCategories
            onClick={(category = {}) => setCurrentArea(category)}
          />
        </>
      )}
    </>
  );
};

DocumentsExpert.propTypes = {
  mediaIsPhone: PropTypes.bool,
  //HOC: state
  isSupervisor: PropTypes.bool,
  filters: PropTypes.object,
  list: PropTypes.array,
  pager: PropTypes.object,
  categories: PropTypes.array,

  // HOC: dispatch
  getCategories: PropTypes.func,
  getDocuments: PropTypes.func,
  searchDocuments: PropTypes.func,
  modalOpen: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { list, filters, pager, categories } = state.documentsExpert;
      const { isSupervisor } = state.user;
      return {
        filters,
        list,
        pager,
        categories,
        isSupervisor,
      };
    },
    (dispatch) => ({
      getCategories: () =>
        dispatch({ type: DOCUMENTS_EXPERT_CATEGORIES_GET._REQUEST }),
      getDocuments: (filters) =>
        dispatch({ type: DOCUMENTS_EXPERT_LIST_GET._REQUEST, filters }),
      searchDocuments: ({ filters, title }) =>
        dispatch({
          type: SEARCH_DOCUMENTS_EXPERT_LIST_GET._REQUEST,
          filters,
          title,
          catalogPage: true,
        }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(DocumentsExpert);
